import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

/**
 * Chip à bascule (filtres par famille, sélections multiples) — le motif
 * « pastille bordée qui s'allume » était réimplémenté à chaque page de filtres.
 */
@Component({
  selector: 'wh-chip-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="rounded-full border px-2.5 py-1 text-xs font-medium transition-colors"
      [class]="stateClass()"
      (click)="toggled.emit(!active())">
      {{ label() }}
    </button>
  `,
})
export class WhChipToggleComponent {
  readonly label = input.required<string>();
  readonly active = input.required<boolean>();
  readonly accent = input<'primary' | 'aquamarine'>('primary');
  readonly toggled = output<boolean>();

  protected readonly stateClass = computed(() => {
    if (!this.active()) return 'border-gray-200 text-gray-400 dark:border-slate-600 dark:text-slate-500';
    return this.accent() === 'aquamarine'
      ? 'border-aquamarine-500 bg-aquamarine-50 text-gray-900 dark:bg-aquamarine-500/10 dark:text-slate-100'
      : 'border-primary-400 bg-primary-50 text-primary-700 dark:bg-primary-500/10 dark:text-primary-300';
  });
}
